/* import __COLOCATED_TEMPLATE__ from './usage-item.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

interface Args {
  itemTitle: string;
  items?: any[];
  suffix?: string;
}

interface Signature {
  Args: Args;
  Blocks: {
    default: [{ item: any }];
  };
}

const MAX_LIST_ITEMS = 3;

export default class AppPackageUninstallModalUsageItem extends Component<Signature> {
  @tracked isExpanded = false;

  get totalItemsCount(): number {
    return this.args.items ? this.args.items.length : 0;
  }

  get items(): any[] {
    return this.args.items ?? [];
  }

  get shouldShowExpandButton(): boolean {
    return this.totalItemsCount > MAX_LIST_ITEMS && !this.isExpanded;
  }

  get visibleItems(): any[] {
    return this.isExpanded ? this.items : this.items.slice(0, MAX_LIST_ITEMS);
  }

  get remainingItemsCount(): number {
    return this.totalItemsCount - MAX_LIST_ITEMS;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Appstore::AppPackage::UninstallModal::UsageItem': typeof AppPackageUninstallModalUsageItem;
  }
}
